import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class EmailCampaignService {

  constructor(private http: HttpClient) { }

  createCampaignTemplates(accountId: string): Observable<any> {
    return this.http
    .post(`/api/v1/admin/email_campaign/add_templates`,
    JSON.stringify({ accountId }));
  }

  getVerifiedSendingDomains(): Observable<any> {
    return this.http
    .get(`/api/v1/email_campaign/verified_domains`);
  }

  getBccTrackingEmail(): Observable<any> {
    return this.http
    .get(`/api/v1/email_campaign/bcc_tracking`);
  }

  updateBccTrackingEmail(bccEmailAddress: string): Observable<any> {
    return this.http
    .post(`/api/v1/email_campaign/bcc_tracking`,
    JSON.stringify({ bccEmailAddress }));
  }

  deleteBccTrackingEmail(): Observable<any> {
    return this.http
    .delete(`/api/v1/email_campaign/bcc_tracking`);
  }
}


// WEBPACK FOOTER //
// ./client/app/services/email-campaign.service.ts